import http from "../http-common";

class MajorService {
  createMajor(data) {
    return http.post(`/api/major`, data);
  }
  getMajors() {
    return http.get(`/api/major`);
  }
  updateMajor(id, data) {
    return http.put(`/api/major/${id}`, data);
  }
}

export default new MajorService();